import { IconButton } from '@mgh-app/component-library';
import { MouseEventHandler, ReactNode } from 'react';
import {
  backgroundColor,
  borderRadius,
  combineCls,
  display,
  dropShadow,
  fontSize,
  gridTemplateRows,
  height,
  margin,
  textAlign,
  twCls,
  width,
} from 'style';

export interface SettingsButtonProps {
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  title?: string;
}

export const SettingsButton = ({ children, onClick, title }: SettingsButtonProps): JSX.Element => {
  return (
    <div className={twCls(display('grid'), gridTemplateRows('grid-rows-2'), margin('my-3'))}>
      <IconButton
        className={combineCls(
          twCls(
            width('w-12'),
            height('h-12'),
            borderRadius('rounded-2xl'),
            backgroundColor('bg-white', 'hover:bg-white'),
            dropShadow('drop-shadow-home'),
            margin('mx-3'),
          ),
        )}
        onClick={onClick}
      >
        {children}
      </IconButton>
      {title && (
        <p className={twCls(margin('mt-3'), fontSize('text-xs'), textAlign('text-center'))}>
          {title}
        </p>
      )}
    </div>
  );
};
